export const LicenseTranslation = {
  en: {
    title: "List of licenses",
    titleAdd: "Add license",
    titleEdit: "Edit license",
    addLicense: "+ Add license",
    email: "Email",
    numberOfUsers: "Number of users",
    createdAt: "Valid since",
    validUntil: "Valid until",
    actions: "Actions",
    deleteLicenseConfirmation:
      'Are you sure you want to delete the license "{label}"?',
    users: "Users",
    username: "Username",
    password: "Password",
    addedUsers: "Added users for {licenseName}",
    removedUsers: "Removed users for {licenseName}",
    licenses: "Licenses",
  },
  ru: {
    title: "Список лицензий",
    titleAdd: "Добавить лицензию",
    titleEdit: "Редактировать лицензию",
    addLicense: "+ Добавить лицензию",
    email: "Эл. почта",
    numberOfUsers: "Количество пользователей",
    createdAt: "Действует с",
    validUntil: "Действует до",
    actions: "Действия",
    deleteLicenseConfirmation:
      'Вы уверены, что хотите удалить лицензию "{label}"?',
    users: "Пользователи",
    username: "Имя пользователя",
    password: "Пароль",
    addedUsers: "Добавленные пользователи для {licenseName}",
    removedUsers: "Удаленные пользователи для {licenseName}",
    licenses: "Лицензии",
  },
  cz: {
    title: "Seznam licencí",
    titleAdd: "Přidat licenci",
    titleEdit: "Upravit licenci",
    addLicense: "+ Přidat licenci",
    email: "Email",
    numberOfUsers: "Počet uživatelů",
    createdAt: "Platné od",
    validUntil: "Platné do",
    actions: "Akce",
    deleteLicenseConfirmation: 'Opravdu chcete smazat licenci "{label}"?',
    users: "Uživatelé",
    username: "Uživatelské jméno",
    password: "Heslo",
    addedUsers: "Přidaní uživatelé pro {licenseName}",
    removedUsers: "Odebraní uživatelé pro {licenseName}",
    licenses: "Licence",
  },
  sk: {
    title: "Zoznam licencií",
    titleAdd: "Pridať licenciu",
    titleEdit: "Upraviť licenciu",
    addLicense: "+ Pridať licenciu",
    email: "Email",
    numberOfUsers: "Počet používateľov",
    createdAt: "Platné od",
    validUntil: "Platné do",
    actions: "Akcie",
    deleteLicenseConfirmation: 'Naozaj chcete odstrániť licenciu "{label}"?',
    users: "Používatelia",
    username: "Používateľské meno",
    password: "Heslo",
    addedUsers: "Pridaní používatelia pre {licenseName}",
    removedUsers: "Odstránení používatelia pre {licenseName}",
    licenses: "Licencie",
  },
  de: {
    title: "Liste der Lizenzen",
    titleAdd: "Lizenz hinzufügen",
    titleEdit: "Lizenz bearbeiten",
    addLicense: "+ Lizenz hinzufügen",
    email: "Email",
    numberOfUsers: "Anzahl der Benutzer",
    createdAt: "Gültig seit",
    validUntil: "Gültig bis",
    actions: "Aktionen",
    deleteLicenseConfirmation:
      'Sind Sie sicher, dass Sie die Lizenz "{label}" löschen möchten?',
    users: "Benutzer",
    username: "Benutzername",
    password: "Passwort",
    addedUsers: "Benutzer für {licenseName} hinzugefügt",
    removedUsers: "Benutzer für {licenseName} entfernt",
    licenses: "Lizenzen",
  },
  hu: {
    title: "Licenclista",
    titleAdd: "Licenc hozzáadása",
    titleEdit: "Licenc szerkesztése",
    addLicense: "+ Licenc hozzáadása",
    email: "Email",
    numberOfUsers: "Felhasználók száma",
    createdAt: "Érvényes ettől",
    validUntil: "Érvényes eddig",
    actions: "Műveletek",
    deleteLicenseConfirmation: 'Biztosan törli a(z) "{label}" licencet?',
    users: "Felhasználók",
    username: "Felhasználónév",
    password: "Jelszó",
    addedUsers: "Hozzáadott felhasználók a(z) {licenseName}-hez",
    removedUsers: "Eltávolított felhasználók a(z) {licenseName}-ről",
    licenses: "Licencek",
  },
  pl: {
    title: "Lista licencji",
    titleAdd: "Dodaj licencję",
    titleEdit: "Edytuj licencję",
    addLicense: "+ Dodaj licencję",
    email: "Email",
    numberOfUsers: "Liczba użytkowników",
    createdAt: "Ważne od",
    validUntil: "Ważne do",
    actions: "Akcje",
    deleteLicenseConfirmation: 'Czy na pewno chcesz usunąć licencję "{label}"?',
    users: "Użytkownicy",
    username: "Nazwa użytkownika",
    password: "Hasło",
    addedUsers: "Dodani użytkownicy dla {licenseName}",
    removedUsers: "Usunięci użytkownicy dla {licenseName}",
    licenses: "Licencje",
  },
  fr: {
    title: "Liste des licences",
    titleAdd: "Ajouter une licence",
    titleEdit: "Modifier la licence",
    addLicense: "+ Ajouter une licence",
    email: "Email",
    numberOfUsers: "Nombre d'utilisateurs",
    createdAt: "Valide depuis",
    validUntil: "Valide jusqu'à",
    actions: "Actions",
    deleteLicenseConfirmation:
      'Êtes-vous sûr de vouloir supprimer la licence "{label}"?',
    users: "Utilisateurs",
    username: "Nom d'utilisateur",
    password: "Mot de passe",
    addedUsers: "Utilisateurs ajoutés pour {licenseName}",
    removedUsers: "Utilisateurs supprimés pour {licenseName}",
    licenses: "Licences",
  },
  es: {
    title: "Lista de licencias",
    titleAdd: "Agregar licencia",
    titleEdit: "Editar licencia",
    addLicense: "+ Agregar licencia",
    email: "Correo electrónico",
    numberOfUsers: "Número de usuarios",
    createdAt: "Válido desde",
    validUntil: "Válido hasta",
    actions: "Acciones",
    deleteLicenseConfirmation:
      '¿Estás seguro de que deseas eliminar la licencia "{label}"?',
    users: "Usuarios",
    username: "Nombre de usuario",
    password: "Contraseña",
    addedUsers: "Usuarios añadidos para {licenseName}",
    removedUsers: "Usuarios eliminados para {licenseName}",
    licenses: "Licencias",
  },
  nl: {
    title: "Lijst van licenties",
    titleAdd: "Licentie toevoegen",
    titleEdit: "Licentie bewerken",
    addLicense: "+ Licentie toevoegen",
    email: "E-mail",
    numberOfUsers: "Aantal gebruikers",
    createdAt: "Geldig sinds",
    validUntil: "Geldig tot",
    actions: "Acties",
    deleteLicenseConfirmation:
      'Weet u zeker dat u de licentie "{label}" wilt verwijderen?',
    users: "Gebruikers",
    username: "Gebruikersnaam",
    password: "Wachtwoord",
    addedUsers: "Toegevoegde gebruikers voor {licenseName}",
    removedUsers: "Verwijderde gebruikers voor {licenseName}",
    licenses: "Licenties",
  },
  sv: {
    title: "Licenslista",
    titleAdd: "Lägg till licens",
    titleEdit: "Redigera licens",
    addLicense: "+ Lägg till licens",
    email: "E-post",
    numberOfUsers: "Antal användare",
    createdAt: "Giltig sedan",
    validUntil: "Giltig till",
    actions: "Åtgärder",
    deleteLicenseConfirmation:
      'Är du säker på att du vill ta bort licensen "{label}"?',
    users: "Användare",
    username: "Användarnamn",
    password: "Lösenord",
    addedUsers: "Tillagda användare för {licenseName}",
    removedUsers: "Borttagna användare för {licenseName}",
    licenses: "Licenser",
  },
  no: {
    title: "Liste over lisenser",
    titleAdd: "Legg til lisens",
    titleEdit: "Rediger lisens",
    addLicense: "+ Legg til lisens",
    email: "E-post",
    numberOfUsers: "Antall brukere",
    createdAt: "Gyldig siden",
    validUntil: "Gyldig til",
    actions: "Handlinger",
    deleteLicenseConfirmation:
      'Er du sikker på at du vil slette lisensen "{label}"?',
    users: "Brukere",
    username: "Brukernavn",
    password: "Passord",
    addedUsers: "Lagt til brukere for {licenseName}",
    removedUsers: "Fjernede brukere for {licenseName}",
    licenses: "Lisenser",
  },
  da: {
    title: "Liste over licenser",
    titleAdd: "Tilføj licens",
    titleEdit: "Rediger licens",
    addLicense: "+ Tilføj licens",
    email: "Email",
    numberOfUsers: "Antal brugere",
    createdAt: "Gyldig siden",
    validUntil: "Gyldig indtil",
    actions: "Handlinger",
    deleteLicenseConfirmation:
      'Er du sikker på, at du vil slette licensen "{label}"?',
    users: "Brugere",
    username: "Brugernavn",
    password: "Adgangskode",
    addedUsers: "Tilføjede brugere til {licenseName}",
    removedUsers: "Fjernede brugere til {licenseName}",
    licenses: "Licenser",
  },
  fi: {
    title: "Lisenssiluettelo",
    titleAdd: "Lisää lisenssi",
    titleEdit: "Muokkaa lisenssiä",
    addLicense: "+ Lisää lisenssi",
    email: "Sähköposti",
    numberOfUsers: "Käyttäjien lukumäärä",
    createdAt: "Voimassa alkaen",
    validUntil: "Voimassa asti",
    actions: "Toiminnot",
    deleteLicenseConfirmation:
      'Oletko varma, että haluat poistaa lisenssin "{label}"?',
    users: "Käyttäjät",
    username: "Käyttäjänimi",
    password: "Salasana",
    addedUsers: "Lisätyt käyttäjät {licenseName} -lisenssille",
    removedUsers: "Poistetut käyttäjät {licenseName} -lisenssiltä",
    licenses: "Lisenssit",
  },
  ar: {
    title: "قائمة التراخيص",
    titleAdd: "إضافة ترخيص",
    titleEdit: "تعديل الترخيص",
    addLicense: "+ إضافة ترخيص",
    email: "البريد الإلكتروني",
    numberOfUsers: "عدد المستخدمين",
    createdAt: "ساري منذ",
    validUntil: "ساري حتى",
    actions: "الإجراءات",
    deleteLicenseConfirmation: 'هل أنت متأكد أنك تريد حذف الترخيص "{label}"؟',
    users: "المستخدمون",
    username: "اسم المستخدم",
    password: "كلمة المرور",
    addedUsers: "المستخدمون المضافون لـ {licenseName}",
    removedUsers: "المستخدمون المحذوفون لـ {licenseName}",
    licenses: "التراخيص",
  },
};

export default LicenseTranslation;
